var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.695,
    height: 24.707,
    viewBox: "0 0 24.695 24.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    d: "M12859.674,20189.352a12.348,12.348,0,1,1,12.342,12.352A12.361,12.361,0,0,1,12859.674,20189.352Zm1.539,0a10.808,10.808,0,1,0,10.8-10.8A10.813,10.813,0,0,0,12861.213,20189.352Zm10.033,5.4v-4.629h-4.631a.771.771,0,0,1,0-1.543h4.631v-4.629a.771.771,0,1,1,1.541,0v4.629h4.641a.771.771,0,0,1,0,1.543h-4.641v4.629a.771.771,0,1,1-1.541,0Z",
    transform: "translate(-12859.674 -20176.996)",
    fill: "#979797"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOn);
export default __webpack_public_path__ + "static/media/plus-on.fa88e4cee34ac2da831be0486f20d2fe.svg";
export { ForwardRef as ReactComponent };